import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Spinner,
} from "reactstrap"
import api from "helpers/Api"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
//components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import * as reportAction from "../../../store/Y2xpZW50RGV0YWl/actions"
import ButtonSpinner from "../../../components/ButtonSpinner"
import { toast } from "react-toastify"
import PhoneInput from "react-phone-number-input"

const ClientDetailsReport = (props) => {
  const { dispatch, searchBtnStyle } = props
  const title = "Client Details Report"

  //Search bar and validations
  const specificDispatch = useDispatch()
  // const empId = localStorage.getItem("empId")
  useEffect(() => {
    dispatch(reportAction.loadRecordsMetaData())
    dispatch(
      reportAction.loadClientDetailsReport({
        page: 1,
        limit: 50,
      })
    )
  }, [])

  const ticketUpdate = useSelector((state) => state.clientDetailsReport)

  const { recordsMetaData = {}, client_details = [] } = ticketUpdate
  console.log(recordsMetaData, "recordsMetaData")

  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  const [pageCount, setPageCount] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState([])
  
  const [downloadLoading, setDownloadLoading] = useState(false)

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  console.log(dateFormate)
  //filter section initial state
  const [clientDetailsReportData, setClientDetailsReportData] = useState({
    clientCode: "",
    mobileNo: "",
    leadNo: "",
    leadFromDate: "",
    leadToDate: "",
    brideName: "",
    groomName: "",
    eventFromDate: "",
    eventToDate: "",
    venueLocation: ""
  })
  //dropdown initial state
  const [clientProfileStatus, setClientProfileStatus] = useState([])
  const [clientProfile, setClientProfile] = useState([])
  const [event, setEvent] = useState([])
  const [company, setCompany] = useState([])
  const [branch, setBranch] = useState([])
  const [leadStatus,setLeadStatus] = useState([])
  const branchListOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === company.value
    )
  //client profile status options
  const clientProfileStatusOptions = [
    { label: "VIP", value: "VIP" },
    { label: "VVIP", value: "VVIP" },
    { label: "OTHERS", value: "OTHERS" },
  ]
// lead status Options
const leadStatusOptions = [
  { label: "BOOKING COMPLETE", value: "PS9" },
  { label: "CLIENT COMPLETED", value: "PS62" },
  { label: "EC COMPLETED", value: "PS37" },
]
  //Handle change

  const handleChange = async (e) => {
    setClientDetailsReportData({
      ...clientDetailsReportData,
      [e.target.name]: e.target.value,
    })
  }
  //RESET FILTER
  const resetForm = () => {
    setLeadStatus([])
    setSearchInput("")
    setCompany([])
    setBranch([])
    setClientDetailsReportData({
      clientCode: "",
      mobileNo: "",
      leadNo: "",
      leadFromDate: "",
      leadToDate: "",
      brideName: "",
      groomName: "",
      eventFromDate: "",
      eventToDate: "",
      venueLocation: ""
    })
    setClientProfile([])
    setClientProfileStatus([])
    setEvent([])
    dispatch(
      reportAction.loadClientDetailsReport({
        page: 1,
        limit: 50,
      })
    )
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)

  //Apply filter submit

  const applyFilter = (e) => {
    e.preventDefault()
    var searchClientCode =
      clientDetailsReportData && clientDetailsReportData.clientCode
        ? clientDetailsReportData.clientCode
        : ""

    var searchMobileNo =
      clientDetailsReportData && clientDetailsReportData.mobileNo
        ? clientDetailsReportData.mobileNo.replace("+91", "")
        : ""

    var searchClientProfile = !isEmpty(clientProfile) ? clientProfile.value : ""

    var searchClientProfileStatus = !isEmpty(clientProfileStatus)
      ? clientProfileStatus.value
      : ""

    var searchLeadStatus = !isEmpty(leadStatus)
    ? leadStatus.value
    : ""

    var searchLeadNo =
      clientDetailsReportData && clientDetailsReportData.leadNo
        ? clientDetailsReportData.leadNo
        : ""

    var searchBride =
      clientDetailsReportData && clientDetailsReportData.brideName
        ? clientDetailsReportData.brideName
        : ""

    var searchGroom =
      clientDetailsReportData && clientDetailsReportData.groomName
        ? clientDetailsReportData.groomName
        : ""

    var searchEvent = !isEmpty(event) ? event.value : ""
    var searchFromDate =
      clientDetailsReportData && clientDetailsReportData.leadFromDate
        ? moment(clientDetailsReportData.leadFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      clientDetailsReportData && clientDetailsReportData.leadToDate
        ? moment(clientDetailsReportData.leadToDate).format("YYYY-MM-DD")
        : ""
    var searchEventFromDate =
      clientDetailsReportData && clientDetailsReportData.eventFromDate
        ? moment(clientDetailsReportData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchEventToDate =
      clientDetailsReportData && clientDetailsReportData.eventToDate
        ? moment(clientDetailsReportData.eventToDate).format("YYYY-MM-DD")
        : ""
    var searchCompany = !isEmpty(company) ? company.value : ""
    var searchBranch = !isEmpty(branch) ? branch.value : ""
    var searchVenue =
      clientDetailsReportData && clientDetailsReportData.venueLocation
        ? clientDetailsReportData.venueLocation
        : ""
    var searchValue = {}
    searchValue.page = pageChange ? pageCount : 1
    searchValue.limit = sizePerPage ? sizePerPage : 50

    if (searchClientCode) {
      searchValue.clientCode = searchClientCode
    }
    if (searchMobileNo) {
      searchValue.mobileNo = searchMobileNo
    }
    if (searchClientProfile) {
      searchValue.clientProfile = searchClientProfile
    }
    if (searchClientProfileStatus) {
      searchValue.profileStatus = searchClientProfileStatus
    }

    if (searchLeadNo) {
      searchValue.leadNo = searchLeadNo
    }
    if (searchBride) {
      searchValue.brideName = searchBride
    }
    if (searchGroom) {
      searchValue.groomName = searchGroom
    }
    if (searchEvent) {
      searchValue.eventId = searchEvent
    }
    if (searchFromDate) {
      searchValue.leadFromDate = searchFromDate
    }
    if (searchToDate) {
      searchValue.leadToDate = searchToDate
    }

    if (searchVenue) {
      searchValue.eventLocation = searchVenue
    }
    if (searchCompany) {
      searchValue.companyId = searchCompany
    }
    if (searchBranch) {
      searchValue.branchId = searchBranch
    }
    if (searchEventFromDate) {
      searchValue.eventFromDate = searchEventFromDate
    }
    if (searchEventToDate) {
      searchValue.eventToDate = searchEventToDate
    }
   
    if (searchCompany) {
      searchValue.companyId = searchCompany
    }
    if (searchBranch) {
      searchValue.branchId = searchBranch
    }
    if (searchLeadStatus) {
      searchValue.leadStatus = searchLeadStatus
    }
    specificDispatch(reportAction.loadClientDetailsReport(searchValue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  //clientDetailsReportTable
  const clientDetailsReportTable =
    !isEmpty(client_details) &&
      client_details.data &&
      client_details.data.length > 0
      ? client_details.data.map((data, index) => {
        const leadNo =
          data && data.leadDetails.length > 0
            ? data.leadDetails.map((m) => m.leadNo).join(", ")
            : "--"

        const leadDate =
          data && data.leadDetails.length > 0
            ? data.leadDetails.filter((date) => date.leadDate !== null && date.leadDate !== undefined)
              .map((m) => moment(m.leadDate).format(dateFormate))
              .join(", ")
            : "--"

        const brideName =
          data && data.leadDetails.length > 0
            ? data.leadDetails
              .map((m) => m.brideName)
              .filter((name) => name)
              .join(", ")
            : "--"

        const groomName =
          data && data.leadDetails.length > 0
            ? data.leadDetails
              .map((m) => m.groomName)
              .filter((name) => name)
              .join(", ")
            : "--"

        const eventName =
          data && data.leadDetails.length > 0
            ? data.leadDetails
              .flatMap((m) => m.eventName)
              .filter((name) => name !== null && name !== undefined)
              .map(m => m)
              .join(", ")
            : "--"
        const eventDate = data && data.leadDetails.length > 0
          ? data.leadDetails
            .flatMap((m) => m.eventDate)
            .filter((date) => date !== null && date !== undefined)
            .map((date) => moment(date).format(dateFormate))
            .join(", ")
          : "--"
        const venueLocation = data && data.leadDetails.length > 0
          ? data.leadDetails
            .flatMap((m) => m.eventLocation)
            .filter((date) => date !== null && date !== undefined)
            .map(m => m).join(", ")
          : "--"
        const processStatus =
          !isEmpty(recordsMetaData) &&
            data.leadDetails.length > 0 &&
            recordsMetaData.processStatusOptions &&
            recordsMetaData.processStatusOptions.length > 0
            ? recordsMetaData.processStatusOptions.find(
              (_) => _.processStatusId === data.leadDetails[0].processStatus
            )
            : ""
        const company = data && data.leadDetails.length > 0
          ? data.leadDetails.filter(m => m.companyName !== null && m.companyName !== undefined && m.companyName !== "")
            .map(m => m.companyName).join(", ")
          : "--"
        const branch = data && data.leadDetails.length > 0
          ? data.leadDetails.filter(m => m.branchName !== null && m.branchName !== undefined && m.branchName !== "")
            .map(m => m.branchName).join(", ")
          : "--"
        return {
          _id: data._id,
          sNo: index + 1,
          company: company,
          branch: branch,
          venue: venueLocation,
          clientCode: data.clientNo ? data.clientNo : "--",
          clientName: data.clientName ? data.clientName : "--",
          mobileNo: data.mobileNo ? data.mobileNo : "--",
          whatsappNo: data.whatsappNo ? data.whatsappNo : "--",
          emailId: data.emailId ? data.emailId : "--",
          clientProfile: data.clientProfileName
            ? data.clientProfileName
            : "--",
          cpRemarks: data.profileRemarks ? data.profileRemarks : "--",
          cpStatus: data.profileStatus ? data.profileStatus : "--",
          clientDOB: data.dob ? moment(data.dob).format(dateFormate) : "--",
          anniversaryDate: data.anniversaryDate
            ? moment(data.anniversaryDate).format(dateFormate)
            : "--",
          leadNo: leadNo,
          leadDate: leadDate ? leadDate : "--",
          brideName: brideName ? brideName : "--",
          groomName: groomName ? groomName : "--",
          eventName: eventName ? eventName : "--",
          eventDate: eventDate ? eventDate : "--",
          status: processStatus,
          // colorCode: colorCode ? colorCode : "",
        }
      })
      : []

  //columns for data table
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      // expandRow: false,
    },
    {
      dataField: "company",
      text: "Company",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "branch",
      text: "Branch",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },

    {
      dataField: "clientCode",
      text: "Client Code",
      hidden: false,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "venue",
      text: "Venue Location",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "mobileNo",
      text: "Mobile No",
      headerStyle: {
        minWidth: "150px",
      },
      hidden: false,
    },
    {
      dataField: "whatsappNo",
      text: "Whatsapp No",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "emailId",
      text: "Email Id",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "clientProfile",
      text: "Client Profile",
      hidden: false,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "cpRemarks",
      text: "CP Remarks",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },

    {
      dataField: "cpStatus",
      text: "CP Status",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "clientDOB",
      text: "Client DOB",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "anniversaryDate",
      text: "Client Anniversary",
      hidden: false,
      headerStyle: {
        minWidth: "166px",
      },
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "status",
      text: "Status",
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <div>
            {!isEmpty(row.status) ? (
              <button
                style={{
                  background: row.status.colorCode,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "2px",
                  borderRadius: "4px",
                }}
              >
                {!isEmpty(row.status) && row.status.label}
              </button>
            ) : (
              "--"
            )}
          </div>
        )
      },
      headerStyle: {
        minWidth: "148px",
      },
    },
  ]
  //Columns section
  const [columns, setColumns] = useState(initialColumns)
  const [columnModal, setColumnModal] = useState(false)
  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }

  const [loading, setLoading] = useState(false)

  //Search filter

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)

    dispatch(
      reportAction.loadClientDetailsReport({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchClientCode =
      clientDetailsReportData && clientDetailsReportData.clientCode
        ? clientDetailsReportData.clientCode
        : ""

    var searchMobileNo =
      clientDetailsReportData && clientDetailsReportData.mobileNo
        ? clientDetailsReportData.mobileNo.replace("+91", "")
        : ""
        var searchLeadStatus = !isEmpty(leadStatus)
        ? leadStatus.value
        : ""
    var searchClientProfile = !isEmpty(clientProfile) ? clientProfile.value : ""

    var searchClientProfileStatus = !isEmpty(clientProfileStatus)
      ? clientProfileStatus.value
      : ""
    var searchEventFromDate =
      clientDetailsReportData && clientDetailsReportData.eventFromDate
        ? moment(clientDetailsReportData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchEventToDate =
      clientDetailsReportData && clientDetailsReportData.eventToDate
        ? moment(clientDetailsReportData.eventToDate).format("YYYY-MM-DD")
        : ""
    var searchCompany = !isEmpty(company) ? company.value : ""
    var searchBranch = !isEmpty(branch) ? branch.value : ""
    var searchVenue =
      clientDetailsReportData && clientDetailsReportData.venueLocation
        ? clientDetailsReportData.venueLocation
        : ""
    var searchLeadNo =
      clientDetailsReportData && clientDetailsReportData.leadNo
        ? clientDetailsReportData.leadNo
        : ""

    var searchBride =
      clientDetailsReportData && clientDetailsReportData.brideName
        ? clientDetailsReportData.brideName
        : ""

    var searchGroom =
      clientDetailsReportData && clientDetailsReportData.groomName
        ? clientDetailsReportData.groomName
        : ""

    var searchEvent = !isEmpty(event) ? event.value : ""
    var searchFromDate =
      clientDetailsReportData && clientDetailsReportData.leadFromDate
        ? moment(clientDetailsReportData.leadFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      clientDetailsReportData && clientDetailsReportData.leadToDate
        ? moment(clientDetailsReportData.leadToDate).format("YYYY-MM-DD")
        : ""
    var searchValue = {}

    if (searchClientCode) {
      searchValue.clientCode = searchClientCode
    }
    if (searchMobileNo) {
      searchValue.mobileNo = searchMobileNo
    }
    if (searchClientProfile) {
      searchValue.clientProfile = searchClientProfile
    }
    if (searchClientProfileStatus) {
      searchValue.profileStatus = searchClientProfileStatus
    }

    if (searchLeadNo) {
      searchValue.leadNo = searchLeadNo
    }
    if (searchBride) {
      searchValue.brideName = searchBride
    }
    if (searchGroom) {
      searchValue.groomName = searchGroom
    }
    if (searchEvent) {
      searchValue.eventId = searchEvent
    }
    if (searchFromDate) {
      searchValue.leadFromDate = searchFromDate
    }
    if (searchToDate) {
      searchValue.leadToDate = searchToDate
    }
    if (searchEventFromDate) {
      searchValue.eventFromDate = searchEventFromDate
    }
    if (searchEventToDate) {
      searchValue.eventToDate = searchEventToDate
    }
    if (searchVenue) {
      searchValue.eventLocation = searchVenue
    }
    if (searchCompany) {
      searchValue.companyId = searchCompany
    }
    if (searchBranch) {
      searchValue.branchId = searchBranch
    }
    if (searchLeadStatus) {
      searchValue.leadStatus = searchLeadStatus
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/get_all_client_info_excel_export`, searchValue)
      .then((response) => {
        const exportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const leadNo =
              data && data.leadDetails.length > 0
                ? data.leadDetails.map((m) => m.leadNo).join(", ")
                : "--"

            const leadDate =
              data && data.leadDetails.length > 0
                ? data.leadDetails.filter((date) => date.leadDate !== null && date.leadDate !== undefined)
                  .map((m) => moment(m.leadDate).format(dateFormate))
                  .join(", ")
                : "--"

            const brideName =
              data && data.leadDetails.length > 0
                ? data.leadDetails.map((m) => m.brideName).join(", ")
                : "--"

            const groomName =
              data && data.leadDetails.length > 0
                ? data.leadDetails.map((m) => m.groomName).join(", ")
                : "--"

            const eventName =
              data && data.leadDetails.length > 0
                ? data.leadDetails.map((m) => m.eventName).join(", ")
                : "--"
            const eventDate = data && data.leadDetails.length > 0
              ? data.leadDetails
                .flatMap((m) => m.eventDate)
                .filter((date) => date !== null && date !== undefined)
                .map((date) => moment(date).format(dateFormate))
                .join(", ")
              : "--"
            const cpRemarkValue = !isEmpty(data.profileRemarks)
              ? data.profileRemarks.replace(/[\r\n,.]/gm, "")
              : "--"
            const leadNoValue = !isEmpty(leadNo)
              ? JSON.stringify(leadNo).replace(/","/g, "\n")
              : "--"

            const leadDateValue = !isEmpty(leadDate)
              ? JSON.stringify(leadDate).replace(/","/g, "\n")
              : "--"

            const brideNameValue = !isEmpty(brideName)
              ? JSON.stringify(brideName).replace(/","/g, "\n")
              : "--"

            const groomNameValue = !isEmpty(groomName)
              ? JSON.stringify(groomName).replace(/","/g, "\n")
              : "--"
            const eventDateValue = !isEmpty(eventDate)
              ? JSON.stringify(eventDate).replace(/","/g, "\n")
              : "--"

            const eventNameValue = !isEmpty(eventName)
              ? JSON.stringify(eventName).replace(/","/g, "\n")
              : "--"
            const processStatusValue =
              data && data.leadDetails.length > 0
                ? data.leadDetails.map((m) => m.processStatus).join(", ")
                : ""
            const processStatus =
              !isEmpty(recordsMetaData) &&
              recordsMetaData.processStatusOptions &&
              recordsMetaData.processStatusOptions.length > 0 &&
              recordsMetaData.processStatusOptions.find(
                (_) => _.processStatusId === processStatusValue
              ) &&
              recordsMetaData.processStatusOptions.find(
                (_) => _.processStatusId === processStatusValue
              ).label
            const venueLocation = data && data.leadDetails.length > 0
              ? data.leadDetails
                .flatMap((m) => m.eventLocation)
                .filter((date) => date !== null && date !== undefined)
                .map(m => m).join(", ")
              : "--"
            const venueValue = !isEmpty(venueLocation)
              ? JSON.stringify(venueLocation).replace(/","/g, "\n")
              : "--"
            const company = data && data.leadDetails.length > 0
              ? data.leadDetails.filter(m => m.companyName !== null && m.companyName !== undefined && m.companyName !== "")
                .map(m => m.companyName).join(", ")
              : "--"
            const branch = data && data.leadDetails.length > 0
              ? data.leadDetails.filter(m => m.branchName !== null && m.branchName !== undefined && m.branchName !== "")
                .map(m => m.branchName).join(", ")
              : "--"
            const companyValue = !isEmpty(company)
              ? JSON.stringify(company).replace(/","/g, "\n")
              : "--"

            const branchValue = !isEmpty(branch)
              ? JSON.stringify(branch).replace(/","/g, "\n")
              : "--"
            return {
              _id: data._id,
              sNo: index + 1,
              clientCode: data.clientNo ? data.clientNo : "--",
              clientName: data.clientName ? data.clientName : "--",
              mobileNo: data.mobileNo ? data.mobileNo : "--",
              whatsappNo: data.whatsappNo ? data.whatsappNo : "--",
              emailId: data.emailId ? data.emailId : "--",
              clientProfile: data.clientProfileName
                ? data.clientProfileName
                : "--",
              cpRemarks: cpRemarkValue,
              cpStatus: data.profileStatus ? data.profileStatus : "--",
              clientDOB: data.dob ? moment(data.dob).format(dateFormate) : "--",
              anniversaryDate: data.anniversaryDate
                ? moment(data.anniversaryDate).format(dateFormate)
                : "--",
              leadNo: leadNoValue,
              leadDate: leadDateValue,
              brideName: brideNameValue,
              groomName: groomNameValue,
              eventName: eventNameValue,
              eventDate: eventDateValue,
              status: processStatus ? processStatus : "--",
              company: companyValue,
              branch: branchValue,
              venue: venueValue,
            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Company,Branch,Client Code,Client Name,Venue Location,Mobile No,Whatsapp No,Email Id,Client Profile,CLient Profile Remarks,Client Profile Status,CLient DOB,CLient Anniversary,Lead No,Lead Date,Bride Name,Groom Name,Event Name,Event Date,Status",
          ]

          let usersCsv =
            !isEmpty(exportDataTable) &&
            exportDataTable.reduce((acc, user) => {
              const {
                sNo,
                company,
                branch,

                clientCode,
                clientName,
                venue,
                mobileNo,
                whatsappNo,
                emailId,
                clientProfile,
                cpRemarks,
                cpStatus,
                clientDOB,
                anniversaryDate,
                leadNo,
                leadDate,
                brideName,
                groomName,
                eventName,
                eventDate,
                status,
              } = user
              acc.push([
                sNo,
                company,
                branch,
                venue,
                clientCode,
                clientName,
                venue,
                mobileNo,
                whatsappNo,
                emailId,
                clientProfile,
                cpRemarks,
                cpStatus,
                clientDOB,
                anniversaryDate,
                leadNo,
                leadDate,
                brideName,
                groomName,
                eventName,
                eventDate,
                status,
              ])


              return acc
            }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "ClientDetailsReport.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => {
        setDownloadLoading(false)
        Promise.reject(error)
      })
  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          noDataIndication={"No Data Found..."}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: client_details.length,
    data:
      !isEmpty(client_details) && client_details.length > 0
        ? client_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(client_details) && client_details.length > 0
        ? client_details
        : []
    if (
      !isEmpty(clientDetailsReportData.clientCode) ||
      !isEmpty(clientDetailsReportData.mobileNo) ||
      !isEmpty(clientProfile) ||
      !isEmpty(clientProfileStatus) ||
      !isEmpty(clientDetailsReportData.eventFromDate) ||
      !isEmpty(clientDetailsReportData.eventToDate) ||
      !isEmpty(clientDetailsReportData.leadNo) ||
      !isEmpty(clientDetailsReportData.brideName) ||
      !isEmpty(clientDetailsReportData.groomName) ||
      !isEmpty(event) ||
      !isEmpty(company) ||
      !isEmpty(branch) ||
      !isEmpty(clientDetailsReportData.venueLocation)||
      !isEmpty(leadStatus)


    ) {
      var searchClientCode =
        clientDetailsReportData && clientDetailsReportData.clientCode
          ? clientDetailsReportData.clientCode
          : ""
          var searchLeadStatus = !isEmpty(leadStatus)
          ? leadStatus.value
          : ""
      var searchMobileNo =
        clientDetailsReportData && clientDetailsReportData.mobileNo
          ? clientDetailsReportData.mobileNo.replace("+91", "")
          : ""
      var searchClientProfile = !isEmpty(clientProfile)
        ? clientProfile.value
        : ""

      var searchClientProfileStatus = !isEmpty(clientProfileStatus)
        ? clientProfileStatus.value
        : ""
      var searchEventFromDate =
        clientDetailsReportData && clientDetailsReportData.eventFromDate
          ? moment(clientDetailsReportData.eventFromDate).format("YYYY-MM-DD")
          : ""
      var searchEventToDate =
        clientDetailsReportData && clientDetailsReportData.eventToDate
          ? moment(clientDetailsReportData.eventToDate).format("YYYY-MM-DD")
          : ""
      var searchCompany = !isEmpty(company) ? company.value : ""
      var searchBranch = !isEmpty(branch) ? branch.value : ""
      var searchVenue =
        clientDetailsReportData && clientDetailsReportData.venueLocation
          ? clientDetailsReportData.venueLocation
          : ""

      var searchLeadNo =
        clientDetailsReportData && clientDetailsReportData.leadNo
          ? clientDetailsReportData.leadNo
          : ""

      var searchBride =
        clientDetailsReportData && clientDetailsReportData.brideName
          ? clientDetailsReportData.brideName
          : ""

      var searchGroom =
        clientDetailsReportData && clientDetailsReportData.groomName
          ? clientDetailsReportData.groomName
          : ""

      var searchEvent = !isEmpty(event) ? event.value : ""
      var searchFromDate =
        clientDetailsReportData && clientDetailsReportData.leadFromDate
          ? moment(clientDetailsReportData.leadFromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        clientDetailsReportData && clientDetailsReportData.leadToDate
          ? moment(clientDetailsReportData.leadToDate).format("YYYY-MM-DD")
          : ""
      var searchValue = {}
      searchValue.page = page
      searchValue.limit = sizePerPage ? sizePerPage : 50

      if (searchClientCode) {
        searchValue.clientCode = searchClientCode
      }
      if (searchMobileNo) {
        searchValue.mobileNo = searchMobileNo
      }
      if (searchClientProfile) {
        searchValue.clientProfile = searchClientProfile
      }
      if (searchClientProfileStatus) {
        searchValue.profileStatus = searchClientProfileStatus
      }
      if (searchLeadNo) {
        searchValue.leadNo = searchLeadNo
      }
      if (searchBride) {
        searchValue.brideName = searchBride
      }
      if (searchGroom) {
        searchValue.groomName = searchGroom
      }
      if (searchEvent) {
        searchValue.eventId = searchEvent
      }
      if (searchFromDate) {
        searchValue.leadFromDate = searchFromDate
      }
      if (searchToDate) {
        searchValue.leadToDate = searchToDate
      }
      if (searchEventFromDate) {
        searchValue.eventFromDate = searchEventFromDate
      }
      if (searchEventToDate) {
        searchValue.eventToDate = searchEventToDate
      }
      if (searchVenue) {
        searchValue.eventLocation = searchVenue
      }
      if (searchCompany) {
        searchValue.companyId = searchCompany
      }
      if (searchBranch) {
        searchValue.branchId = searchBranch
      }
      if (searchLeadStatus) {
        searchValue.leadStatus = searchLeadStatus
      }
      setPageLoad(!pageLoad)
      setLoading(true)
      specificDispatch(reportAction.loadClientDetailsReport(searchValue))
    } else {
      dispatch(
        reportAction.loadClientDetailsReport({
          page: page,
          limit: sizePerPage,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Tickets"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Label"}>
                            {"Company"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="company"
                          value={company}
                          options={
                            recordsMetaData.companyOptions
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          onChange={(e) => {
                            setCompany(e)
                          }}
                          placeholder="Select Company"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Label"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          value={branch}
                          options={branchListOptions
                            ? branchListOptions
                            : []
                          }
                          onChange={(e) => {
                            setBranch(e)
                          }}
                          placeholder="Select Branch"
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Client Code"}
                          >
                            {"Client Code"}
                          </Label>
                        </div>

                        <Input
                          type="text"
                          name="clientCode"
                          value={clientDetailsReportData.clientCode}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Client Code"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Mobile No"}>
                            {"Mobile No"}
                          </Label>
                        </div>

                        <PhoneInput
                          maxlength={15}
                          international
                          countryCallingCodeEditable={false}
                          defaultCountry={"IN"}
                          name="mobileNo"
                          style={{ flex: "2" }}
                          value={clientDetailsReportData.mobileNo}
                          onChange={(e) => {
                            console.log("-------", e)
                            const re = /^[0-9\b/+]+$/
                            if (e === "" || re.test(e)) {
                              handleChange({
                                target: {
                                  name: "mobileNo",
                                  value: e,
                                },
                              })
                            } else {
                              handleChange({
                                target: {
                                  name: "mobileNo",
                                  value: "",
                                },
                              })
                            }
                          }}
                          placeholder="+91"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Lead No"}>
                            {"Lead No"}
                          </Label>
                        </div>

                        <Input
                          type="text"
                          name="leadNo"
                          value={clientDetailsReportData.leadNo}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Lead No"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Lead Date"}>
                            {"Lead From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="leadFromDate"
                          value={clientDetailsReportData.leadFromDate}
                          max={clientDetailsReportData.leadToDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Lead Date"}>
                            {"Lead To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="leadToDate"
                          value={clientDetailsReportData.leadToDate}
                          min={clientDetailsReportData.leadToDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Label"}>
                            {"Client Profile"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="clientProfile"
                          value={clientProfile}
                          options={
                            recordsMetaData.clientProfileOptions
                              ? recordsMetaData.clientProfileOptions
                              : []
                          }
                          onChange={(e) => {
                            setClientProfile(e)
                          }}
                          placeholder="Select Client Profile"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Label"}>
                            {"Client Profile Status"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="clientProfileStatus"
                          value={clientProfileStatus}
                          options={clientProfileStatusOptions}
                          onChange={(e) => {
                            setClientProfileStatus(e)
                          }}
                          placeholder="Select Client Profile Status"
                        />
                      </Col>


                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Lead Date"}>
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="eventFromDate"
                          value={clientDetailsReportData.eventFromDate}
                          max={clientDetailsReportData.eventToDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Lead Date"}>
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="eventToDate"
                          value={clientDetailsReportData.eventToDate}
                          min={clientDetailsReportData.eventFromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Venue Location"}
                          >
                            {"Venue Location"}
                          </Label>
                        </div>

                        <Input
                          type="text"
                          name="venueLocation"
                          value={clientDetailsReportData.venueLocation}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Venue Location"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Label"}>
                            {"Event Name"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="event"
                          value={event}
                          options={
                            recordsMetaData.eventOptions
                              ? recordsMetaData.eventOptions
                              : []
                          }
                          onChange={(e) => {
                            setEvent(e)
                          }}
                          placeholder="Select Event"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Bride Name"}
                          >
                            {"Bride Name"}
                          </Label>
                        </div>

                        <Input
                          type="text"
                          name="brideName"
                          value={clientDetailsReportData.brideName}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Bride Name"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Groom Name"}
                          >
                            {"Groom Name"}
                          </Label>
                        </div>

                        <Input
                          type="text"
                          name="groomName"
                          value={clientDetailsReportData.groomName}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Groom Name"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Label"}>
                            {"Lead Status"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="leadStatus"
                          value={leadStatus}
                          options={ leadStatusOptions? leadStatusOptions : []}
                          onChange={(e) => {
                            setLeadStatus(e)
                          }}
                          placeholder="Select Lead Status"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-4">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={clientDetailsReportTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      client_details.totalDataCount
                        ? client_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                  {loading ? (
                    <Modal
                      show={loading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {columnModal && (
            <Modal size="xl" show={columnModal}>
              <Modal.Header
                style={{
                  backgroundColor: "white",
                  color: "black",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Edit Columns
                <span>
                  <i
                    className="fa fa-times quote-close"
                    aria-hidden="true"
                    onClick={() => setColumnModal(false)}
                  ></i>
                </span>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <div>
                    <Input
                      type="checkbox"
                      checked={selectedColumns.length === columns.length}
                      onChange={(e) => handleSelectAllChange(e)}
                      style={{ width: "15px", height: "15px" }}
                    />
                    <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                      Select All
                    </Label>
                  </div>
                </Row>
                <Row>
                  <Col sm="12" md="6" lg="6" className="ml-4">
                    {oddColumnData.map((column) => (
                      <div key={column.dataField} className="d-flex flex-row">
                        <div className="form-check form-check-inline">
                          <Input
                            type="checkbox"
                            value={column.dataField}
                            checked={selectedColumns.includes(column.dataField)}
                            onChange={(e) => handleCheckboxChange(e)}
                            style={{ width: "15px", height: "15px" }}
                          />
                          <Label
                            style={{
                              fontSize: "16px",
                              marginLeft: "10px",
                            }}
                          >
                            {column.text}
                          </Label>
                        </div>
                      </div>
                    ))}
                  </Col>
                  <Col sm="12" md="6" lg="6">
                    {evenColumnData.map((column) => (
                      <div key={column.dataField} className="d-flex flex-row">
                        <div className="form-check form-check-inline">
                          <Input
                            type="checkbox"
                            value={column.dataField}
                            checked={selectedColumns.includes(column.dataField)}
                            onChange={(e) => handleCheckboxChange(e)}
                            style={{ width: "15px", height: "15px" }}
                          />
                          <Label
                            style={{
                              fontSize: "16px",
                              marginLeft: "10px",
                            }}
                          >
                            {column.text}
                          </Label>
                        </div>
                      </div>
                    ))}
                  </Col>
                </Row>
              </Modal.Body>

              <Modal.Footer>
                <p
                  className="text-decoration-underline text-info"
                  style={{ cursor: "pointer", fontSize: "16px" }}
                  onClick={handleRestoreToDefault}
                >
                  Restore To Default
                </p>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setColumnModal(false)
                    setSelectedColumns(selectColumn)
                  }}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={() => handleSaveColumns()}
                >
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {downloadLoading ? (
            <Modal
              show={downloadLoading}
              style={{ width: "7%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

ClientDetailsReport.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  title: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})
//ClientDetailsReport
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClientDetailsReport)
)
